(function () {
  const SEL_BTN = '#ss-load-more';
  const SEL_GRID = '#product-grid';
  let loading = false;
  let observer = null;

  const grid = () => document.querySelector(SEL_GRID);
  const button = () => document.querySelector(SEL_BTN);

  async function loadMore() {
    const btn = button();
    const g = grid();
    if (loading || !btn || !g) return;
    const url = btn.getAttribute('data-next-url');
    if (!url) return;

    loading = true;
    const original = btn.textContent;
    btn.textContent = 'Caricamento…';
    btn.setAttribute('aria-busy', 'true');

    try {
      const res = await fetch(url);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      // Aggiunge i nuovi prodotti alla griglia attuale
      doc.querySelectorAll(SEL_GRID + ' > li').forEach((li) => g.appendChild(li));

      // Aggiorna l'URL nella barra (utile per "torna indietro" e condivisione)
      history.replaceState(null, '', url);

      // C'è una pagina successiva?
      const nextBtn = doc.querySelector(SEL_BTN);
      const nextUrl = nextBtn && nextBtn.getAttribute('data-next-url');
      if (nextUrl) {
        btn.setAttribute('data-next-url', nextUrl);
        btn.textContent = original;
        btn.removeAttribute('aria-busy');
      } else {
        const wrap = btn.closest('#ss-load-more-wrap');
        if (wrap) wrap.remove();
        if (observer) observer.disconnect();
      }
    } catch (e) {
      btn.textContent = 'Riprova';
      btn.removeAttribute('aria-busy');
    } finally {
      loading = false;
    }
  }

  // Click delegato: sopravvive al re-render dei filtri Dawn
  document.addEventListener('click', (e) => {
    if (e.target.closest(SEL_BTN)) { e.preventDefault(); loadMore(); }
  });

  // --- AUTO-LOAD allo scroll (SCROLL INFINITO) ---
  // Per usare SOLO il pulsante, commenta la riga "observe();" e il blocco MutationObserver.
  function observe() {
    const btn = button();
    if (!btn || !('IntersectionObserver' in window)) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      (entries) => { if (entries.some((en) => en.isIntersecting)) loadMore(); },
      { rootMargin: '600px' }
    );
    observer.observe(btn);
  }
  observe();

  // Riaggancia l'observer quando Dawn ricarica la griglia (applicazione filtri)
  const container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    new MutationObserver(() => observe()).observe(container, { childList: true, subtree: true });
  }
})();